module.exports = __webpack_public_path__ + "static/wild-flowers-d11fdee6123054d795ec9f1e3542e74d.jpg";